import { PlatformLink } from 'components/PlatformLink'

import { useTranslation } from 'services/i18n'

import { MessageReference } from 'types/Api'
import { getTrackingPropsForReferenceEvents } from 'utils/getTrackingPropsForReferenceEvents'

import type { FC } from 'react'

type Props = {
  reference: MessageReference
}

export const GoToReferenceButton: FC<Props> = ({ reference }) => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'conversation.references_panel',
  })

  const { sourceType, url } = reference

  if (!url) return null

  const stopClickPropagation = (e: React.MouseEvent | React.KeyboardEvent) => {
    e.stopPropagation()
  }

  return (
    <div>
      <PlatformLink
        appSourceType="kaila_reference_preview"
        className="kui-btn kui-btn-primary kui-btn-small text-sm"
        onClick={stopClickPropagation}
        trackingName="kai_open_reference_in_kora_clicked"
        trackingProps={getTrackingPropsForReferenceEvents({ reference, source: 'references_panel' })}
        url={url}
      >
        {sourceType === 'karnov_document'
          ? t('open_in_karnov')
          : t('go_to_document')}
      </PlatformLink>
    </div>
  )
}
